module.exports = __webpack_public_path__ + "img/2d7b981.jpg";